import { defineClassNames } from '../utils/defineClassNames';

export const popoverClasses = defineClassNames('popover', {
  root: {
    variants: { skin: ['light', 'dark'] },
    states: ['fluid'],
  },
  element: {},
});

export const popoverContentClasses = defineClassNames('popover-content', {
  root: {
    variants: {
      status: ['open', 'close'],
      placement: [
        'top',
        'top-start',
        'top-end',
        'bottom',
        'bottom-start',
        'bottom-end',
        'left',
        'left-start',
        'left-end',
        'right',
        'right-start',
        'right-end',
        'auto',
        'auto-start',
        'auto-end',
      ],
      skin: ['light', 'dark'],
    },
  },
  content: {
    variants: { skin: ['light', 'dark'] },
    states: ['hasArrow'],
  },
  arrow: { variants: { skin: ['light', 'dark'] } },
});

export type PopoverTransitionStatus = 'open' | 'close';
